module.exports = "query { przelewy24Methods { is_sandbox items { p24_id name sort_order img_url mobile_img_url } } }"